import React, { FC } from 'react';
import { ReactComponent as Email } from '../../../assets/Common/Email.svg';

export const EmailIcon: FC = () => <Email />;
